import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { shouldHideBottomNav, NAV_ITEMS } from '../../constants/navigation';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';

const BottomNav: React.FC = () => {
  const location = useLocation();
  const flags = useFeatureFlags();

  if (shouldHideBottomNav(location.pathname)) return null;

  const navItems = NAV_ITEMS.filter((item) => !item.requiresFlag || flags[item.requiresFlag]);

  return (
    // Icon-led bottom nav: lucide glyph above a small label. Active tab turns brand teal.
    // Tokens via CSS custom properties so light and dark themes flip automatically.
    <div
      className='md:hidden fixed bottom-0 left-0 right-0 z-50 pb-safe border-t'
      style={{
        background: 'var(--color-bg-glass)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderColor: 'var(--color-border)',
      }}
    >
      <div className='flex items-stretch px-2 py-1.5'>
        {navItems.map((item) => {
          const isActive = item.exact
            ? location.pathname === item.path
            : location.pathname.startsWith(item.path);
          const tint = isActive ? 'var(--color-primary)' : 'var(--color-text-muted)';

          return (
            <Link
              key={item.name}
              to={item.path}
              className='flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0'
              style={{ '--tw-ring-color': 'var(--color-primary)' } as React.CSSProperties}
              aria-current={isActive ? 'page' : undefined}
            >
              <item.Icon
                size={22}
                strokeWidth={isActive ? 2.4 : 2}
                style={{ color: tint }}
                aria-hidden='true'
              />
              <span
                className='text-[10px] tracking-tight'
                style={{ fontWeight: isActive ? 700 : 500, color: tint }}
              >
                {item.name}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
